import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Book, Headphones, Music2, Video, Settings2 } from 'lucide-react';
import GitaLogo from '../GitaLogo';

const NAV_ITEMS = [
  { to: '/', label: 'Home', icon: Home, key: 'home' },
  { to: '/chapters', label: 'Chapters', icon: Book, key: 'chapters' },
  { to: '/watch', label: 'Watch', icon: Video, key: 'watch' },
  { to: '/listen', label: 'Listen', icon: Headphones, key: 'listen' },
  { to: '/listen/stream', label: 'Stream', icon: Music2, key: 'stream' }
];

const brandFor = (active) => NAV_ITEMS.find((item) => item.key === active) ?? NAV_ITEMS[2];

export function PlayerMobileNav({ active, showSettings, onToggleSettings }) {
  const brand = brandFor(active);

  return (
    <header className="spotify-mobile-nav lg:hidden">
      <Link to={brand.to} className="spotify-logo text-base">
        <GitaLogo size={32} theme="dark" className="spotify-logo-mark shrink-0" />
        <span>{brand.label}</span>
      </Link>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onToggleSettings}
          className={`spotify-mobile-link ${showSettings ? 'active' : ''}`}
          aria-label="Settings"
        >
          <Settings2 className="w-4 h-4" />
        </button>
        {NAV_ITEMS.filter((item) => item.key !== active).map((item) => (
          <Link key={item.key} to={item.to} className="spotify-mobile-link" aria-label={item.label}>
            <item.icon className="w-4 h-4" />
          </Link>
        ))}
      </div>
    </header>
  );
}

export function PlayerSidebar({ active, children }) {
  const brand = brandFor(active);

  return (
    <aside className="spotify-sidebar">
      <Link to={brand.to} className="spotify-logo">
        <GitaLogo size={36} theme="dark" className="spotify-logo-mark shrink-0" />
        <span>{brand.label}</span>
      </Link>

      <nav className="spotify-nav">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          if (item.key === active) {
            return (
              <span key={item.key} className="spotify-nav-item active">
                <Icon className="w-5 h-5" />
                {item.label}
              </span>
            );
          }
          return (
            <Link key={item.key} to={item.to} className="spotify-nav-item">
              <Icon className="w-5 h-5" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      {children}
    </aside>
  );
}
